import { isMacosPlatform } from '@utils/auth';
import { useEffect, useState } from 'react';
import { hasAuthParams, useAuth } from 'react-oidc-context';

export const AuthStateMonitor = () => {
    const auth = useAuth();
    const [hasTriedSignin, setHasTriedSignin] = useState(false);

    // check if we're in an auth callback route
    const isAuthParams = hasAuthParams();

    useEffect(() => {
        // attpt silent sign-in on app load if not authenticated.
        // Skipped inside the native macOS shell: there is no
        // silent_redirect_uri configured, so the call always fails there and
        // only leaves a stale error in auth state while the native bridge
        // (useNativeBridgeAuth) does the real sign-in.
        if (
            !isAuthParams &&
            !auth.isAuthenticated &&
            !auth.isLoading &&
            !hasTriedSignin &&
            !isMacosPlatform()
        ) {
            console.log('Attempting silent signin.');
            auth.signinSilent().catch(error => {
                console.log('Silent sign-in failed (no session):', error);
            });
            setHasTriedSignin(true);
        }

        if (auth.isAuthenticated) {
            console.log('user is authenticated');
        }
    }, [auth, isAuthParams, hasTriedSignin]);

    // This component doesn't render anything
    return null;
};

export default AuthStateMonitor;
